/**
 * TanStack Query hooks for `cap-types-approved-payout-revenue-clicks-conversion-pending`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys,
	type CreateCapTypesApprovedPayoutRevenueClicksConversionPendingBody,
	type ListCapTypesApprovedPayoutRevenueClicksConversionPendingResponse,
	type CapTypesApprovedPayoutRevenueClicksConversionPendingRow,
} from "./api";

export function useCapTypesApprovedPayoutRevenueClicksConversionPendingList(): UseQueryResult<ListCapTypesApprovedPayoutRevenueClicksConversionPendingResponse, Error> {
	return useQuery({
		queryKey: capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapTypesApprovedPayoutRevenueClicksConversionPendingCreate(): UseMutationResult<CapTypesApprovedPayoutRevenueClicksConversionPendingRow, Error, CreateCapTypesApprovedPayoutRevenueClicksConversionPendingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys.all });
		},
	});
}

export function useCapTypesApprovedPayoutRevenueClicksConversionPendingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys.all });
		},
	});
}
